import { Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { cabinetRoutesData, publicRoutesData } from "routes/routesData";
// import DelayedFallback from "./delayedFallback";
import PersonalCabinetLayout from "components/layout/personalCabinetLayout";
import PublicLayout from "components/layout/publicLayout";
import ProtectedRoutes from "./protectedRoutes";
import PublicRoutes from "./publicRoutes";

export default function RoutesBuilder() {
  return (
    // <Suspense fallback={<DelayedFallback delay={10000}>Loading...</DelayedFallback>}>
    <Suspense>
      {/* fallback={<div>Loading...</div>} */}
      <Routes>
        <Route element={<PublicLayout />}>
          {publicRoutesData.map(({ path, Comp, props }, index) => (
            <Route
              key={index}
              path={path}
              element={
                <PublicRoutes>
                  <Comp {...props} />
                </PublicRoutes>
              }
            />
          ))}
        </Route>

        <Route element={<PersonalCabinetLayout />}>
          {cabinetRoutesData.map(({ path, Comp, props }, index) => (
            <Route
              key={index}
              path={path}
              element={
                <ProtectedRoutes>
                  <Comp {...props} />
                </ProtectedRoutes>
              }
            />
          ))}
        </Route>

        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Suspense>
  );
}
